import { Link as MUILink } from '@mui/material'
import type { CSSObject } from '@mui/material/styles'
import { styled } from '../../utils/styled'
import type { LinkColor } from './types'

export const StyledLink = styled(MUILink, {
  shouldForwardProp: (prop) => prop !== 'linkColor'
})<{ linkColor?: LinkColor }>(({ theme, linkColor = 'default' }): CSSObject => {
  if (linkColor === 'grey') {
    return {
      textDecoration: 'underline',
      cursor: 'pointer',
      color: theme.tokens.foreground.main.secondary,
      '&:visited': {
        color: theme.tokens.foreground.main.secondary
      },
      '&:hover': {
        color: theme.tokens.foreground.main.primary,
        textDecoration: 'underline'
      }
    }
  }

  return {
    textDecoration: 'none',
    cursor: 'pointer',
    color: theme.tokens.foreground.main.link,
    '&:visited': {
      color: theme.tokens.foreground.main.link
    },
    '&:hover': {
      textDecoration: 'underline'
    }
  }
})
